import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $error,
  $verificationRequest,
  FlowFilters,
  getVerification,
  setFlowFilters,
  verificationRequestMounted,
  verificationRequestUnmounted,
} from './model'
import { Verification, Error } from './types'

export const useVerificationProfile = (filters: FlowFilters) => {
  const verificationRequest = useStore<Verification>($verificationRequest)
  const error = useStore<Error>($error)
  const loading = useStore(getVerification.pending)

  const filtersKey = JSON.stringify(filters)

  React.useEffect(() => {
    setFlowFilters(filters)
  }, [filtersKey])

  React.useEffect(() => {
    verificationRequestMounted()
    return () => verificationRequestUnmounted()
  }, [])

  return { verificationRequest, error, loading }
}
